import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllBooks, deleteBook } from '../utils/api';
import Header from '../components/Header';

interface Book {
  _id: string;
  title: string;
  authors: string[];
  publication: string;
  cost: number;
  quantityInStock: number;
}

const Dashboard: React.FC = () => {
  const [books, setBooks] = useState<Book[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      const data = await getAllBooks();
      setBooks(data);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch books');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBook = async (id: string) => {
    if (window.confirm('Are you sure you want to delete this book?')) {
      try {
        await deleteBook(id);
        setBooks(books.filter((b) => b._id !== id));
      } catch (err: any) {
        setError(err.response?.data?.message || 'Failed to delete book');
      }
    }
  };

  if (loading) return (
    <>
      <Header title="Books Management" />
      <div className="dashboard">Loading...</div>
    </>
  );

  return (
    <>
      <Header title="Books Management" />
      <div className="dashboard">
        <div className="dashboard-content">
          <div className="section">
            <div className="section-header">
              <h2>Books Management</h2>
              <button onClick={() => navigate('/books/new')} className="btn-primary">
                + Add New Book
              </button>
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="table-container">
              <table className="table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Authors</th>
                    <th>Publication</th>
                    <th>Cost</th>
                    <th>Stock</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {books.map((book) => (
                    <tr key={book._id}>
                      <td>{book.title}</td>
                      <td>{book.authors.join(', ')}</td>
                      <td>{book.publication}</td>
                      <td>₹{book.cost}</td>
                      <td>{book.quantityInStock}</td>
                      <td className="action-cell">
                        <button
                          onClick={() => navigate(`/books/${book._id}`)}
                          className="btn-small btn-edit"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDeleteBook(book._id)}
                          className="btn-small btn-delete"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {books.length === 0 && <p className="no-data">No books found. Create one to get started!</p>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
